/* RESPONSIBLE TEAM: team-fin-qa */
// Bridge route for QA review sidedrawer under assigned reviews (inbox)
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class InboxReviewsAssignedReviewRoute extends Route {
  analytics = {
    section: 'inbox',
    place: 'inbox.reviews.assigned.review',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(InboxReviewsAssignedReviewRoute);
